import { makeError } from '../../api/apiError';
import CeremonyShell from './components/CeremonyShell';
import CeremonyError from './components/CeremonyError';
import './CeremonyPage.css';
import './components/ceremony-components.css';

/**
 * Catch-all fallback for any route that isn't a valid
 * /ceremony/:ceremonyId (e.g. a bare "/ceremony", a typo'd path, or a QR
 * link that lost its path segment). Reuses the same "incomplete link" copy
 * as a well-formed-but-missing access_key, since both describe a link that
 * cannot possibly be resolved without more information — no network call is
 * made.
 */
export default function InvalidLinkPage() {
  return (
    <CeremonyShell>
      <CeremonyError error={makeError('incomplete')} />
    </CeremonyShell>
  );
}
